module.exports = __webpack_public_path__ + "static/mainland-furniture-493f1c73451dd609ab1eaf1b39f0cba0.png";